import React, { useRef, useState } from 'react';
import * as yup from 'yup';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import { ICON_SAVE, ICON_CANCEL } from '../extras/icons';
import ButtonSpinner from '../layout/ButtonSpinner';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { changePasswordAction } from '../../actions/authActions';
//Función principal
const ChangePasswordForm = props => {
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo los props
    const { show, handleClose, preventCancel } = props;
    //Genero los ref
    const refOldPassword = useRef();
    //Inicializo datos
    const initialData = {
        oldPassword: '',
        newPassword: '',
        newPasswordRepeat: ''
    }
    //Traigo el state
    const loading = useSelector(state => state.auth.loading );
    //Manejo evento de apertura
    const handleOnShow = () => {
        refOldPassword.current.focus();
    }
    //Manejo el guardado
    const handleSave = values => {
        //Si está todo ok
        const data = {
            oldPassword: values.oldPassword,
            newPassword: values.newPassword,
            newPasswordRepeat: values.newPasswordRepeat
        }
        //Llamo al dispatch
        dispatch( changePasswordAction(data, handleClose) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        oldPassword: yup.string().required('El campo es obligatorio'),
        newPassword: yup.string().min(6).nullable(),
        newPasswordRepeat: yup.string().min(6).oneOf([yup.ref('newPassword'), null], 'Debe coincidir con la nueva contraseña')
    });
    //Manejo el cierre
    const handleOnHide = () => {
        if(preventCancel){
            return false;
        }else{
            handleClose();
        }
    }
    //Inicializo las properties
    let modalProps = {
        show,
        onHide: handleOnHide,
        onShow: handleOnShow,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true
    }
    //Verifico si hay cancel
    if(preventCancel){
        modalProps = {
            ...modalProps,
            backdrop: 'static',
            keyboard: false
        }
    }
    //Renderizo
    return (
        <Modal
            {
                ...modalProps
            }
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Cambiar contraseña
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        A continuación puede actualizar su contraseña. La nueva debe contener al menos <strong>6 caracteres</strong>.
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="oldPassword"
                                        className="form-control" 
                                        name="oldPassword" 
                                        type="password" 
                                        placeholder="Ingrese clave actual"
                                        value={ values.oldPassword }
                                        onChange={handleChange}
                                        isInvalid={!!errors.oldPassword}
                                        disabled={ loading }
                                        ref={refOldPassword}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.oldPassword }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="newPassword"
                                        className="form-control" 
                                        name="newPassword" 
                                        type="password" 
                                        placeholder="Nueva contraseña"
                                        value={ values.newPassword }
                                        onChange={handleChange}
                                        isInvalid={!!errors.newPassword}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.newPassword }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="newPasswordRepeat"
                                        className="form-control" 
                                        name="newPasswordRepeat" 
                                        type="password" 
                                        placeholder="Confirmar contraseña"
                                        value={ values.newPasswordRepeat }
                                        onChange={handleChange}
                                        isInvalid={!!errors.newPasswordRepeat}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.newPasswordRepeat }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            {
                                !preventCancel ? (
                                    <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                        <ICON_CANCEL /> Cancelar
                                    </Button>
                                ) : null
                            }
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ChangePasswordForm;